export default {
      id: "icon-angle-fat-usage",
      viewBox: "0 0 199.404 199.404",
      url: __webpack_public_path__ + "icons.svg#icon-angle-fat",
      toString: function () {
        return this.url;
      }
    }